export const ActionType = {
  GET_TAGS_ARRAY_START: "GET_TAGS_ARRAY_START",
  GET_TAGS_ARRAY_SUCCESS: "GET_TAGS_ARRAY_SUCCESS",
  GET_TAGS_ARRAY_ERROR: "GET_TAGS_ARRAY_ERROR"
};
